<template>
  <list-table
    :url="url"
    title="لیست تیکت ها"
    :detailUrl="detailUrl"
    :newUrl="newUrl"
    :fields="fields"
    :params="params"
    :tabTable="tabTable"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import httpHelper from "@/helpers/httpHelper";

export default {
  name: "messages",
  data: function () {
    return {
      url: "tickets",
      detailUrl: "ticketDetails",
      newUrl: "addTicket",
      ticketList: [],
      department_options: [],
      fields: [
        {
          key: "id",
          label: "شماره تیکت",
        },
        {
          key: "subject",
          label: "عنوان",
        },
        {
          key: "ticket_departments.name",
          label: "دپارتمان",
        },
        {
          key: "user.name",
          label: "کاربر ",
        },
        {
          key: "user.mobile",
          label: "موبایل ",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
          formatter: (value, key, item) => {
            return persianDate.getDate(value) + ' , ' + persianDate.getTime(value);
          },
        },
        {
          key: "ticket_status.title",
          label: "وضعیت",
        },
        {
          label: "درجه اهمیت",
          key: "ticket_periority.title",
          tdClass(value, key, item){
            return value=='کم' ? 'text-primary' : value=='متوسط' ? 'text-warning' : 'text-danger';
          }
        },
        {
          key: "updated_at",
          label: "تاریخ آخرین تغییر",
          formatter: (value, key, item) => {
            return persianDate.getDate(value) + ' , ' + persianDate.getTime(value);
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
         {
          label: "از تاریخ",
          field: "start_date",
          type: "date-picker",
        },
        {
          label: "تا تاریخ",
          field: "end_date",
          type: "date-picker",
        },
        {
          label: "نام کاربر",
          field: "customer_name",
          type: "text",
        },
        {
          label: "شماره تیکت",
          field: "id_t",
          type: "text",
        },
        {
          label: "عنوان یا متن",
          field: "title",
          type: "text",
        },
        {
          label: "دپارتمان",
          field: "department_id",
          type: "select",
          options: [],
        },
        {
          label: "درجه اهمیت",
          field: "ticket_periority",
          type: "mddropdown",
          group: 2,
        },
      ],
      tabTable: {
          field: "mdid1_status",
          type: "tablist",
          group: 1,
        },
    };
  },
  components: {
    "list-table": TableShowData,
  },
  created() {
    httpHelper.setAuth();
    this.Getdepartment();
  },
  methods: {
    Getdepartment() {
      httpHelper
        .getData("departments")
        .then((response) => {
          
          this.department_options = response.result.map((item) => {
            return { value: item.id, text: item.name };
          });
        })
        .catch((error) => {})
        .finally(() => {
          this.department_options.push({value:null,text:'انتخاب نشده'})
          this.params[5].options = this.department_options.reverse();
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست تیکت ها" }]);
  },
};
</script>